import forEachElement from '../principles/selectors/forEachElement';

/**
 This file should contain all progress indicator js.
 The js for different indicators (e.g. bar vs. dots) can be exported separately
*/

/**
 * Updates width progress bar and progress bar text (if used)
 *
 * @param {element} leadformWrapper Outermost wrapper class of leadform, as a DOMElement
 * @param {array} previousPanels Array of panels that have been completed
 */
export default function updateProgressBar(leadformWrapper, previousPanels) {
  forEachElement(leadformWrapper.querySelectorAll('.progress-wrapper--bar'), progressWrapper => {
    const totalSteps = progressWrapper.dataset.totalSteps;

    // update width inline to % of steps user has completed
    forEachElement(progressWrapper.querySelectorAll('.progress-bar__indicator'), indicator =>
      indicator.style.width = `${previousPanels.length / totalSteps * 100}%`
    );

    // update text
    forEachElement(progressWrapper.querySelectorAll('.progress__text'), progressText =>
      progressText.innerHTML = `${previousPanels.length} of ${totalSteps}`
    );
  });
}



// WEBPACK FOOTER //
// ./client/app/scripts/components/_progress-indicators.js